import { ContainerStatusEnum, ModeOfExportEnum } from "@gtpl/shared-models/common-models";

export class ContainerDetailsModel {
    containerNumber: string;
    lineSeal: string;
    eSeal: string;
    blNo: string;
    scac: string;
    bookingNo: string;
    status: ContainerStatusEnum;
    refNo: string;
    trackingNo:string;
    vesselName:string;
    portOfTranshipment:string;
    portOfDischarge:string;
    importingVesselName:string;
    dateOfTranshipment:string;
    shippedOnboardDate:string;
    dischargeDate:string;
    destinationDate:string;
    tempIndicatorNo1?:string;
    tempIndicatorNo2?:string;
    tempIndicatorNo3?:string;
    temperaturee?:string;
    etd?:Date;
    containerSize?:String;
    vesselNumber?:string
    modeOfExport?:ModeOfExportEnum



    constructor (containerNumber: string, lineSeal: string, eSeal: string, blNo:string,scac:string,bookingNo:string,status: ContainerStatusEnum,refNo:string,
    trackingNo:string,
    vesselName:string,
    portOfTranshipment:string,
    portOfDischarge:string,
    importingVesselName:string,
    dateOfTranshipment:string,
    shippedOnboardDate:string,
    dischargeDate:string,
    destinationDate:string,tempIndicatorNo1?:string, tempIndicatorNo2?:string,tempIndicatorNo3?:string, temperaturee?:string,etd?:Date,containerSize?:String,vesselNumber?:string,
    modeOfExport?:ModeOfExportEnum
) {
       this.containerNumber=containerNumber;
       this.lineSeal=lineSeal;
       this.eSeal=eSeal;
       this.blNo=blNo;
       this.scac=scac;
       this.bookingNo=bookingNo;
       this.status=status;
       this.refNo=refNo;
       this.trackingNo= trackingNo;
        this.vesselName= vesselName;
        this.portOfTranshipment= portOfTranshipment;
        this.portOfDischarge= portOfDischarge;
        this.importingVesselName= importingVesselName;
        this.dateOfTranshipment= dateOfTranshipment;
        this.shippedOnboardDate= shippedOnboardDate;
        this.dischargeDate= dischargeDate;
        this.destinationDate= destinationDate;
        this.tempIndicatorNo1=tempIndicatorNo1;
        this.tempIndicatorNo2=tempIndicatorNo2;
        this.temperaturee=temperaturee
        this.tempIndicatorNo3=tempIndicatorNo3
        this.etd=etd
        this.containerSize=containerSize
        this.vesselNumber=vesselNumber
        this.modeOfExport = modeOfExport
    }
}